import { ILog } from '../../../global/types';
import { ICommand } from 'core-ts-types';

export type EmailSubjects = 'reset' | 'confirm';

export interface IEmailSentStateParams extends ng.ui.IStateParamsService {
  subject: EmailSubjects;
  email: string;
}

export class EmailSentController {
  public email: string;

  constructor(
    private $stateParams: IEmailSentStateParams,
    private resendConfirmEmailCommand: ICommand,
    private resendResetPasswordCommand: ICommand,
    private log: ILog
  ) {
    this.email = $stateParams.email;
  }

  resendEmail() {
    this.resendResetPasswordCommand(this.email).then(() => {
      this.log.user.success({
        content: 'The email has been resent.',
        timeout: 10000,
        dismissOnTimeout: true,
        dismissButton: true
      });
    });
  }
}

angular.module('capability-ng-user-app').controller('ngEmailSentController', EmailSentController);



// WEBPACK FOOTER //
// ./app/lib/user_app/views/email_sent/email_sent.ts